// extracted by mini-css-extract-plugin
export var addressFields = "_py-0";
export var animationContainer = "_py-1";
export var footer = "_py-2";
export var lineItems = "_py-3";
export var modalContent = "_py-4";
export var orderName = "_py-5";
export var strong = "_py-6";
export var warning = "_py-7";